import numberWithCommas from './numberWithComma'

const getPriceString = price =>
  price === 0 ? 'P.O.A' : `$${numberWithCommas(price)}`
export default getPriceString
